import { IStorage } from "../Interfaces";

export class Status {

    expertise;
    status;
    completion ;
    questionCount= 0;
    lastAnswerCount = 0;

    constructor(_expertise:string,_status:string,_questionCount:number,_lastAnswerCount:number,_completion?:any){
        this.expertise = _expertise;
        this.status = _status;
        this.completion =  Math.round((_lastAnswerCount/_questionCount) * 100);
        this.questionCount = _questionCount;
        this.lastAnswerCount = _lastAnswerCount === 0 ? 0 : _lastAnswerCount ;
    }

    getArrayStatus(){
        const storage:string |null = localStorage.getItem("StatusForm")
        if(storage)
        {
            const jsonStorage:IStorage[] = JSON.parse(storage)           
             
            const statusToShare = jsonStorage.findIndex(index => index.expertise === this.expertise);
            jsonStorage.splice(statusToShare,1)

            return jsonStorage

        } 
    } 
    
};


